export const SET_THEME = (state, theme) => {
  state.theme = theme
}
